var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.5 48.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5f2c7e;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #5f277e;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_and_text",
    "data-name": "Icon and text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.25,36.25v9c0,1.1-.9,2-2,2H6.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.25,13.25H52.25c1.1,0,2,.9,2,2v10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.25,13.25c-2.76,0-5-1.34-5-3s2.24-3,5-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.25,47.25c-2.76,0-5-1.34-5-3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.25,
    y1: 44.25,
    x2: 1.25,
    y2: 11.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "46.59 13.25 42.46 1.25 7.6 13.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.25,
    y1: 7.25,
    x2: 24.58,
    y2: 7.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.25,13.25v-4c0-1.1-.9-2-2-2h-5.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 43.25,
    cy: 30.25,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.25,
    y1: 25.25,
    x2: 54.25,
    y2: 25.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.25,21.25h1c1.1,0,2,.9,2,2v10c0,1.1-.9,2-2,2h-15.7c-1.27,0-2.3-1.03-2.3-2.3v-5.41c0-1.27,1.03-2.3,2.3-2.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_icon.ad51b103608b294836ea7a9589f037f7.svg";
export { ForwardRef as ReactComponent };